import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import staffReducer from './authSlice';
import projectCompanyReducer from './projectCompanySlice';
// @ts-ignore
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';

const persistConfig = {
	key: 'root',
	storage,
};

const persistedReducer = persistReducer(persistConfig, staffReducer);

export const store = configureStore({
	reducer: {
		auth: persistedReducer,
		projectCompany: projectCompanyReducer,
	},
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export const persistor = persistStore(store);

export type AppThunk<ReturnType = void> = ThunkAction<
	ReturnType,
	RootState,
	unknown,
	Action<string>
>;
